// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendario {
  max-height: 500px;
  overflow: auto;
}

.historico {
  width: 100%;
  height: 50px;
  margin: 12px 8px;
  text-align: center;
}
.historico .opcion {
  margin: 0 8px;
  border-radius: 8px;
  padding: 8px;
  min-width: 100px;
  background-color: #424242;
  color: #ffffff;
  text-align: center;
}
.historico .opcion.activada {
  background-color: #a3a3a3;
}
.historico .opcion:hover {
  cursor: pointer;
  background-color: #6e6e6e;
}`, "",{"version":3,"sources":["webpack://./src/app/modulos/crm/components/trato/trato-principal/trato-principal.component.scss","webpack://./src/assets/css/colores.scss"],"names":[],"mappings":"AAEA;EACC,iBAAA;EACA,cAAA;AADD;;AAGA;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAAD;AACC;EACC,aAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBCQgB;EDPhB,cAAA;EACA,kBAAA;AACF;AAAE;EACC,yBCGc;ADDjB;AACE;EACC,eAAA;EACA,yBCHQ;ADIX","sourcesContent":["@import \"../../../../../../assets/css/colores.scss\";\r\n\r\n.calendario{\r\n\tmax-height: 500px;\r\n\toverflow: auto;\r\n}\r\n.historico{\r\n\twidth: 100%;\r\n\theight: 50px;\r\n\tmargin: 12px 8px;\r\n\ttext-align: center;\r\n\t.opcion {\r\n\t\tmargin: 0 8px;\r\n\t\tborder-radius: 8px;\r\n\t\tpadding: 8px;\r\n\t\tmin-width: 100px;\r\n\t\tbackground-color: $oa-gris-oscuro;\r\n\t\tcolor: #ffffff;\r\n\t\ttext-align: center;\r\n\t\t&.activada{\r\n\t\t\tbackground-color: $oa-gris-claro;\r\n\t\t}\r\n\r\n\t\t&:hover{\r\n\t\t\tcursor: pointer;\r\n\t\t\tbackground-color: $oa-gris;\r\n\t\t}\r\n\r\n\t}\r\n}\r\n\r\n","\r\n$oa-principal : #d20a31;\r\n$oa-principal2 : #6d0015;\r\n$oa-principal3 : #f06f88;\r\n\r\n$oa-secundario : #0a738c;\r\n$oa-secundario2 : #023b48;\r\n$oa-secundario3 : #539cad;\r\n\r\n$oa-accent : #46c309;\r\n$oa-accent2 : #216500;\r\n$oa-accent3 : #90e268;\r\n\r\n$oa-accent-secundario : #E1750B;\r\n$oa-accent-secundario2 : #753A00;\r\n$oa-accent-secundario3 : #FFBA76;\r\n\r\n$oa-background : #023b48;\r\n\r\n$oa-blanco-bg : white;\r\n$oa-blanco : white;\r\n\r\n$oa-gris : #6e6e6e;\r\n$oa-gris-claro : #a3a3a3;\r\n$oa-gris-oscuro : #424242;\r\n\r\n$oa-color-link: #3e92ff;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
